import { render, staticRenderFns } from "./HistoryNorthList.vue?vue&type=template&id=dca988fe"
import script from "./HistoryNorthList.vue?vue&type=script&lang=js"
export * from "./HistoryNorthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports